export default __webpack_public_path__ + "案例选择界面-引导图片4.png";